// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file common/v1/common.proto (package workernet.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/common.proto.
 */
export const file_common_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_any]);

/**
 * @generated from message workernet.common.SnmpSettings
 */
export type SnmpSettings = Message<"workernet.common.SnmpSettings"> & {
  /**
   * @generated from field: int64 version = 1;
   */
  version: bigint;

  /**
   * @generated from field: int64 port = 2;
   */
  port: bigint;

  /**
   * @generated from field: int64 timeout = 3;
   */
  timeout: bigint;

  /**
   * @generated from field: int64 retries = 4;
   */
  retries: bigint;

  /**
   * @generated from field: string community = 5;
   */
  community: string;

  /**
   * @generated from field: string security_name = 6;
   */
  securityName: string;

  /**
   * @generated from field: workernet.common.SnmpSecurityLevel security_level = 7;
   */
  securityLevel: SnmpSecurityLevel;

  /**
   * @generated from field: workernet.common.AuthProtocol auth_protocol = 8;
   */
  authProtocol: AuthProtocol;

  /**
   * @generated from field: string auth_passphrase = 9;
   */
  authPassphrase: string;

  /**
   * @generated from field: workernet.common.PrivProtocol priv_protocol = 10;
   */
  privProtocol: PrivProtocol;

  /**
   * @generated from field: string priv_passphrase = 11;
   */
  privPassphrase: string;

  /**
   * @generated from field: string context_name = 12;
   */
  contextName: string;

  /**
   * @generated from field: string context_engine_id = 13;
   */
  contextEngineId: string;
};

/**
 * Describes the message workernet.common.SnmpSettings.
 * Use `create(SnmpSettingsSchema)` to create a new message.
 */
export const SnmpSettingsSchema: GenMessage<SnmpSettings> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 0);

/**
 * @generated from message workernet.common.TelnetSettings
 */
export type TelnetSettings = Message<"workernet.common.TelnetSettings"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string enable_password = 3;
   */
  enablePassword: string;

  /**
   * @generated from field: int64 port = 4;
   */
  port: bigint;

  /**
   * @generated from field: int64 ssh_port = 5;
   */
  sshPort: bigint;
};

/**
 * Describes the message workernet.common.TelnetSettings.
 * Use `create(TelnetSettingsSchema)` to create a new message.
 */
export const TelnetSettingsSchema: GenMessage<TelnetSettings> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 1);

/**
 * @generated from message workernet.common.Behaviors
 */
export type Behaviors = Message<"workernet.common.Behaviors"> & {
  /**
   * @generated from field: optional int64 arp = 1;
   */
  arp?: bigint | undefined;

  /**
   * @generated from field: optional int64 fdb = 2;
   */
  fdb?: bigint | undefined;

  /**
   * @generated from field: optional int64 iface = 3;
   */
  iface?: bigint | undefined;

  /**
   * @generated from field: optional int64 vlan = 4;
   */
  vlan?: bigint | undefined;

  /**
   * @generated from field: optional int64 pon = 5;
   */
  pon?: bigint | undefined;

  /**
   * @generated from field: optional int64 tdr = 6;
   */
  tdr?: bigint | undefined;

  /**
   * @generated from field: optional int64 radio = 7;
   */
  radio?: bigint | undefined;
};

/**
 * Describes the message workernet.common.Behaviors.
 * Use `create(BehaviorsSchema)` to create a new message.
 */
export const BehaviorsSchema: GenMessage<Behaviors> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 2);

/**
 * @generated from message workernet.common.Device
 */
export type Device = Message<"workernet.common.Device"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: optional string id = 2;
   */
  id?: string | undefined;

  /**
   * @generated from field: workernet.common.SnmpSettings snmp = 3;
   */
  snmp?: SnmpSettings | undefined;

  /**
   * @generated from field: workernet.common.TelnetSettings telnet = 4;
   */
  telnet?: TelnetSettings | undefined;

  /**
   * @generated from field: workernet.common.Behaviors behaviors = 5;
   */
  behaviors?: Behaviors | undefined;
};

/**
 * Describes the message workernet.common.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 3);

/**
 * @generated from message workernet.common.ResponseDevice
 */
export type ResponseDevice = Message<"workernet.common.ResponseDevice"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string ip = 2;
   */
  ip: string;
};

/**
 * Describes the message workernet.common.ResponseDevice.
 * Use `create(ResponseDeviceSchema)` to create a new message.
 */
export const ResponseDeviceSchema: GenMessage<ResponseDevice> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 4);

/**
 * @generated from message workernet.common.ResponseError
 */
export type ResponseError = Message<"workernet.common.ResponseError"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated string traceback = 3;
   */
  traceback: string[];
};

/**
 * Describes the message workernet.common.ResponseError.
 * Use `create(ResponseErrorSchema)` to create a new message.
 */
export const ResponseErrorSchema: GenMessage<ResponseError> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 5);

/**
 * @generated from message workernet.common.Response
 */
export type Response = Message<"workernet.common.Response"> & {
  /**
   * @generated from field: workernet.common.ResponseStatus status = 1;
   */
  status: ResponseStatus;

  /**
   * @generated from field: workernet.common.ResponseDevice device = 2;
   */
  device?: ResponseDevice | undefined;

  /**
   * @generated from field: optional google.protobuf.Any payload = 3;
   */
  payload?: Any | undefined;

  /**
   * @generated from field: google.protobuf.Any result = 4;
   */
  result?: Any | undefined;

  /**
   * @generated from field: optional workernet.common.ResponseError error = 5;
   */
  error?: ResponseError | undefined;
};

/**
 * Describes the message workernet.common.Response.
 * Use `create(ResponseSchema)` to create a new message.
 */
export const ResponseSchema: GenMessage<Response> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 6);

/**
 * @generated from message workernet.common.ServiceStatusContext
 */
export type ServiceStatusContext = Message<"workernet.common.ServiceStatusContext"> & {
  /**
   * @generated from field: optional string satellite_id = 1;
   */
  satelliteId?: string | undefined;

  /**
   * @generated from field: optional string behaviors = 2;
   */
  behaviors?: string | undefined;
};

/**
 * Describes the message workernet.common.ServiceStatusContext.
 * Use `create(ServiceStatusContextSchema)` to create a new message.
 */
export const ServiceStatusContextSchema: GenMessage<ServiceStatusContext> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 7);

/**
 * @generated from message workernet.common.ServiceStatusMessage
 */
export type ServiceStatusMessage = Message<"workernet.common.ServiceStatusMessage"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: workernet.common.ServiceStatus status = 3;
   */
  status: ServiceStatus;

  /**
   * @generated from field: string time = 4;
   */
  time: string;

  /**
   * @generated from field: optional workernet.common.ServiceStatusContext context = 5;
   */
  context?: ServiceStatusContext | undefined;
};

/**
 * Describes the message workernet.common.ServiceStatusMessage.
 * Use `create(ServiceStatusMessageSchema)` to create a new message.
 */
export const ServiceStatusMessageSchema: GenMessage<ServiceStatusMessage> = /*@__PURE__*/
  messageDesc(file_common_v1_common, 8);

/**
 * @generated from enum workernet.common.SnmpSecurityLevel
 */
export enum SnmpSecurityLevel {
  /**
   * @generated from enum value: NO_AUTH_OR_PRIVACY = 0;
   */
  NO_AUTH_OR_PRIVACY = 0,

  /**
   * @generated from enum value: AUTH_WITHOUT_PRIVACY = 1;
   */
  AUTH_WITHOUT_PRIVACY = 1,

  /**
   * @generated from enum value: AUTH_WITH_PRIVACY = 2;
   */
  AUTH_WITH_PRIVACY = 2,
}

/**
 * Describes the enum workernet.common.SnmpSecurityLevel.
 */
export const SnmpSecurityLevelSchema: GenEnum<SnmpSecurityLevel> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 0);

/**
 * @generated from enum workernet.common.AuthProtocol
 */
export enum AuthProtocol {
  /**
   * @generated from enum value: MD5 = 0;
   */
  MD5 = 0,

  /**
   * @generated from enum value: SHA = 1;
   */
  SHA = 1,
}

/**
 * Describes the enum workernet.common.AuthProtocol.
 */
export const AuthProtocolSchema: GenEnum<AuthProtocol> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 1);

/**
 * @generated from enum workernet.common.PrivProtocol
 */
export enum PrivProtocol {
  /**
   * @generated from enum value: DES = 0;
   */
  DES = 0,

  /**
   * @generated from enum value: AES = 1;
   */
  AES = 1,
}

/**
 * Describes the enum workernet.common.PrivProtocol.
 */
export const PrivProtocolSchema: GenEnum<PrivProtocol> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 2);

/**
 * @generated from enum workernet.common.ResponseStatus
 */
export enum ResponseStatus {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: ERROR = 1;
   */
  ERROR = 1,
}

/**
 * Describes the enum workernet.common.ResponseStatus.
 */
export const ResponseStatusSchema: GenEnum<ResponseStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 3);

/**
 * @generated from enum workernet.common.ServiceStatus
 */
export enum ServiceStatus {
  /**
   * @generated from enum value: START = 0;
   */
  START = 0,

  /**
   * @generated from enum value: STOP = 1;
   */
  STOP = 1,
}

/**
 * Describes the enum workernet.common.ServiceStatus.
 */
export const ServiceStatusSchema: GenEnum<ServiceStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 4);

/**
 * @generated from enum workernet.common.PonType
 */
export enum PonType {
  /**
   * @generated from enum value: EPON = 0;
   */
  EPON = 0,

  /**
   * @generated from enum value: GPON = 1;
   */
  GPON = 1,

  /**
   * @generated from enum value: UNKNOWN = 2;
   */
  UNKNOWN = 2,
}

/**
 * Describes the enum workernet.common.PonType.
 */
export const PonTypeSchema: GenEnum<PonType> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 5);

/**
 * @generated from enum workernet.common.DeregReasonType
 */
export enum DeregReasonType {
  /**
   * @generated from enum value: LOS = 0;
   */
  LOS = 0,

  /**
   * @generated from enum value: LOSI = 1;
   */
  LOSI = 1,

  /**
   * @generated from enum value: LOFI = 2;
   */
  LOFI = 2,

  /**
   * @generated from enum value: OTHER = 3;
   */
  OTHER = 3,
}

/**
 * Describes the enum workernet.common.DeregReasonType.
 */
export const DeregReasonTypeSchema: GenEnum<DeregReasonType> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 6);

/**
 * @generated from enum workernet.common.IfStatus
 */
export enum IfStatus {
  /**
   * @generated from enum value: UP = 0;
   */
  UP = 0,

  /**
   * @generated from enum value: DOWN = 1;
   */
  DOWN = 1,
}

/**
 * Describes the enum workernet.common.IfStatus.
 */
export const IfStatusSchema: GenEnum<IfStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_common, 7);

